import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-transport-list',
  templateUrl: './transport-list.component.html',
  styleUrls: ['./transport-list.component.scss']
})
export class TransportListComponent implements OnInit {

  public menus = [];
  public selected = [];
  TransportList;
  isLoading;
  isDeleting;
  DeletingItem;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal,private TokenService: TokenService) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['ShippingMethodDefinitions']) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.GetTransportList();
  }

  GetTransportList() {
    this.http.get<any>(environment.url + 'TransportWays/GetTransportWays').subscribe(data => {
      this.TransportList = data;
      this.isLoading = true;
    });
  }
  gotoTransportEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/definitions/edit-transport'], navigatioExtra);
  }
  
  DeleteTransport() {
    this.isDeleting = true;
    var body = { StatusRef: this.DeletingItem };
    this.http.post<any>(environment.url + 'TransportWays/RemoveTransportWay', body).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      this.GetTransportList();
      if (!data.Error) {
        this.modalService.dismissAll();
        this.toastr.success("Ulaşım Yolu Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Ulaşım Yolu Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }

  DeleteTransportModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }
}
